import { GroupAttributionIocSidePanelWebComponent } from './component/GroupAttributionIocSidePanelWebComponent';

export { GroupAttributionIocSidePanelWebComponent };
